<irb-common-overlay #overlayComponent></irb-common-overlay>
<tooltip-container></tooltip-container>
<calltoaction-container></calltoaction-container>
<hover-panel-container></hover-panel-container>

<div class="h-100">
  <div class="navigationbar">
    @if (progressVisible$ | async) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
    <irb-common-main-menu [menuconfig]='userdata' [menuData]='menuconfigData' class="mainmenu" ></irb-common-main-menu>
    @if (backdropVisible$ | async) {
      <div class="backdrop"></div>
    }
  </div>
  <mat-drawer-container>
    <mat-drawer mode="side">
      <div class="drawer-border"></div>
      @if (backdropVisible$ | async) {
        <div class="backdrop"></div>
      }
    </mat-drawer>

    <mat-drawer-content class="contentLayout" [class.no-overflow]="backdropVisible$ | async" [class]="{'home-background-cls': homeBckgCls}">
      @if (backdropVisible$ | async) {
        <div class="backdrop"></div>
      }
      <router-outlet></router-outlet>
      @if (loadFooter) {
        <irb-common-footer></irb-common-footer>
      }
    </mat-drawer-content>
  </mat-drawer-container>
  @if (backdropVisible$ | async) {
    <div class="backdrop"></div>
  }

  <irb-common-dialog #dialog></irb-common-dialog>
  <irb-editor-sidebar slot="A"></irb-editor-sidebar>
  <irb-editor-sidebar slot="B" [isModal]="true"></irb-editor-sidebar>
  <irb-editor-sidebar slot="C" [isModal]="true"></irb-editor-sidebar>
</div>

<p-toast key="irb-embedded-link-toast" [style]="{marginTop: '80px'}" [baseZIndex]="9999999" position="top-center" [style.z-index]="9999999">
  <ng-template let-message pTemplate="message">
    @if (message.severity === 'success') {
      <span class="ui-toast-icon pi pi-check"></span>
    }
    @if (message.severity === 'error') {
      <span class="ui-toast-icon pi pi-times-circle"></span>
    }
    @if (message.severity === 'warn') {
      <span class="ui-toast-icon pi pi-exclamation-triangle"></span>
    }
    <div class="ui-toast-message-text-content">
      <div class="ui-toast-summary">{{message.summary}}</div>
      <div class="ui-toast-detail">{{message.detail}} <a (click)="message.callBack()">{{message.linkText}}</a></div>
    </div>
  </ng-template>
</p-toast>

<p-toast key="irb-import-sec-job-message" [style]="{marginTop: '80px'}" [baseZIndex]="9999999" position="top-center" (onClose)="onCloseImportSecuritiesAlert()" [style.z-index]="9999999"></p-toast>

<p-toast key="irb-spinner-toast" [style]="{marginTop: '80px'}" [baseZIndex]="9999999" position="top-center" [style.z-index]="9999999">
  <ng-template let-message pTemplate="message">
    <span class='loading-spinner left' style="width: 40px; margin-right: -20px;"></span>
    <div class="ui-toast-message-text-content">
      <div class="ui-toast-summary">{{message.summary}}</div>
      <div class="ui-toast-detail">{{message.detail}} <a (click)="message.callBack()">{{message.linkText}}</a></div>
    </div>
  </ng-template>
</p-toast>

<p-toast [style]="{marginTop: '80px'}" [baseZIndex]="9999999" position="top-center" [style.z-index]="9999999"></p-toast>

<svg focusable="false" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" style="display: none;">
    <symbol id="icon-sch-success" viewBox="0 0 24 24"><path d="M18.885 5.394c0.453-0.492 1.222-0.528 1.718-0.078 0.463 0.419 0.525 1.112 0.163 1.603l-0.084 0.102-10.65 11.586c-0.437 0.475-1.165 0.522-1.658 0.129l-0.102-0.091-4.917-4.902c-0.474-0.472-0.472-1.236 0.004-1.707 0.444-0.439 1.145-0.467 1.621-0.084l0.099 0.088 4.017 4.004z"></path></symbol>
</svg>
